import UserSessionService from "../../UserSessionService";
import WsService from "../../WsService";
import InboundTransactionExtended from "../../../domain/Transaction/inbound/InboundTransactionExtended";
import InboundRedeemableResponse from "domain/Transaction/inbound/InboundRedeemableResponse";
import BasicAuthGenerator from "utils/BasicAuthGenerator";


const ENDPOINT_BASE = "/transactions/inbound";

export default class InboundTransactionService {

    static retrieve(transactionId) {

        let endpoint = ENDPOINT_BASE + "/" + transactionId;

        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let headers = {
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new InboundTransactionExtended(response)
            },
            response => {
                return response;
            });
    }

    static retrieveByToken(token) {

        let endpoint = ENDPOINT_BASE + "?token=" + token;

        return WsService.getWithHeaders(endpoint, {}, 200, {"Authorization": "none"}).then(
            response => {
                return new InboundTransactionExtended(response)
            },
            response => {
                return response;
            });
    }

    static retrieveByRedemptionId(redemptionId){
        let endpoint = ENDPOINT_BASE + "/redemption/" + redemptionId;

        let registrationHeaders = UserSessionService.retrieveRegisteringHeaders();

        let headers = {
            "Authorization": BasicAuthGenerator.create(registrationHeaders["registering-partner-username"], registrationHeaders["registering-partner-password"]),
            'registering-partner-id': registrationHeaders["registering-partner-id"],
            'registering-channel-id': registrationHeaders["registering-channel-id"]
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new InboundTransactionExtended(response)
            },
            response => {
                return response;
            });
    }

    static isRedeemable(inboundTransactionId) {

        let endpoint = ENDPOINT_BASE + "/" + inboundTransactionId + "/is-redeemable"

        let registrationAuth = UserSessionService.retrieveRegisteringAuth();
        let transactionHeaders = UserSessionService.retrieveTransactingHeaders();
        let headers = {
            "Authorization": BasicAuthGenerator.create(
                registrationAuth["registering-partner-username"],
                registrationAuth["registering-partner-password"]
            ),
            ...transactionHeaders
        };

        return WsService.getWithHeaders(endpoint, {}, 200, headers).then(
            response => {
                return new InboundRedeemableResponse(response);
            },
            response => {
                return response;
            });
    }
}
